// Contract names arrive as a pipe-delimited path with an optional trailing Salesforce
// id, e.g. "Primo Brands|Mars United|Pure Life Toy Story|Q2-3 26 - 006Rd00000VFQLKIA5".
// The ledger shows the advertiser (first segment) prominently and the remaining segments
// muted; the Salesforce id is stripped from the display entirely.

export interface ParsedContractName {
  advertiser: string;
  rest: string;
}

// Salesforce contract ids are the 15/18-char "006…" keys, appended as " - <id>".
const SF_SUFFIX = /\s-\s006[0-9A-Za-z]{9,15}\s*$/;

export default function parseContractName(raw: string | null | undefined): ParsedContractName {
  const name = (raw ?? '').trim();
  const match = SF_SUFFIX.exec(name);
  const body = (match ? name.slice(0, match.index) : name).trim();
  const segments = body
    .split('|')
    .map((s) => s.trim())
    .filter(Boolean);
  return {
    advertiser: segments[0] ?? '',
    rest: segments.slice(1).join(' · '),
  };
}
